<template>
    <div v-if="orderItems.length > 1" class="mt-4">
        <template v-if="isShow">
            <div>
                <div class="mt-3 lg:mt-4" v-for="(item, idx) of orderItems" :key="`order-item-${idx}`"
                    v-show="idx != 0" >
                    <div class="flex items-start mb-2 border-t border-a-brown-d7c7b8 pt-3 lg:pt-4">
                        <div class="ml-0 mr-2 mt-1">
                            <div class="py-0.5 px-1 border border-a-brown-502314 rounded-5 font-bold">
                                {{ item.quantity }}x</div>
                        </div>
                        <div class="ml-0 mr-auto pr-1 campaign-name">{{ localeCode ==
                                1033 ?  item.nameEN  : item.name  }}</div>
                        <div class="ml-auto mr-0">{{ item.pricePerUnit }} {{lbl.myOrder.bath}}</div>
                    </div>
                    <div class="ml-8 text-12 lg:text-14">
                        <p v-for="(other, otherIndex) in item.others" :key="`other-item-${otherIndex}`">
                            {{ other.Quantity }}x {{ localeCode == 1033 ? other.NameEN : other.Name }}
                        </p>
                        <div class="pt-3 text-12 lg:text-14" v-for="(addons, addonsIndex) in item.addons"
                        :key="`addons-${addonsIndex}`">
                            <p class="text-14 lg:text-16">{{ localeCode === 1033 ? addons.HeaderEN : addons.Header }}</p>
                            <p v-for="(addonItem, addonItemIndex) in addons.Items" :key="`addon-item-${addonItemIndex}`">
                                {{ addonItem.Quantity }}x {{ localeCode == 1033 ? addonItem.NameEN : addonItem.Name }} (+{{ addonItem.PricePerUnit }} {{lbl.myOrder.bath}})
                            </p>
                        </div>
                        <!-- <div class="pt-3 text-12 lg:text-14" v-for="(chooses, choosesIndex) in item.chooses"
                            :key="`chooses-${choosesIndex}`">
                            <p class="text-14 lg:text-16">{{ localeCode === 1033 ? chooses.headerEN : chooses.header }}</p>
                            <p v-for="(addonItem, addonItemIndex) in chooses.addonItems" :key="`addon-item-${addonItemIndex}`">
                                {{ addonItem.Quantity }}x {{ localeCode == 1033 ? addonItem.NameEN : addonItem.Name }} (+{{ addonItem.TotalAmount }} {{lbl.myOrder.bath}})
                            </p>
                            <p v-for="(ingredientItems, ingredientItemIndex) in chooses.ingredientItems" :key="`ingredient-item-${ingredientItemIndex}`">
                                {{ lbl.myOrder.except }} {{ localeCode == 1033 ? ingredientItems.NameEN : ingredientItems.Name }}
                            </p>
                        </div> -->

                        <div class="pt-3" v-for="(appetizers, appetizersIndex) in item.appetizers"
                            :key="`appetizers-${appetizersIndex}`">
                            <p class="text-14">{{ localeCode === 1033 ? appetizers.HeaderEN : appetizers.Header }}</p>
                            <p v-for="(appetizersItem, appetizersItemIndex) in appetizers.Items" :key="`appetizers-item-${appetizersItemIndex}`">
                                {{ appetizersItem.Quantity }}x {{ localeCode == 1033 ? appetizersItem.NameEN : appetizersItem.Name }} (+{{ appetizersItem.PricePerUnit }} {{lbl.myOrder.bath}})
                            </p>
                        </div>
                    </div>
                    <!-- <div class="ml-8 text-12 lg:text-14">
                        <p v-for="(itemsExtra, j) in item.extra" :key="`extra-item-${j}`">{{ itemsExtra.Quantity }} x {{
                                localeCode ==
                                    1033 ? itemsExtra.NameEn : itemsExtra.Name
                        }}</p>

                        <p v-for="(rem, k) in item.remark" :key="`extra-item-${k}`">{{ lbl.myOrder.except }} {{
                                localeCode ==
                                    1033 ?
                                    rem.name_en : rem.name
                        }}</p>
                    </div> -->
                </div>
            </div>
        </template>

        <div class="flex items-center mt-3 lg:mt-4 cursor-pointer border-t"
            :class="[isShow ? 'border-a-brown-d7c7b8 pt-3 lg:pt-4' : 'border-transparent']" @click="toggle()">
            <div>{{ isShow ? lbl.myOrder.lessDetail : lbl.myOrder.moreDetail }}</div>
            <button type="button" class="outline-none appearance-none bg-none ml-auto mr-0">
                <img src="@/assets/icon/ic-arrow-down-brown.svg" class="transform"
                    :class="[isShow ? 'rotate-180 duration-300' : 'rotate-0 duration-300']" />
            </button>
        </div>
    </div>
</template>
<script>
import { inject, ref } from 'vue'

export default {
    name: 'OrderItemList',
    setup: function () {
        const { lbl, localeCode } = inject("LocaleStore")
        const orderItems = inject("getOrderItems")
        const isShow = ref(false)

        const toggle = function () {
            isShow.value = !isShow.value
        }

        return {
            lbl,
            localeCode,
            isShow,
            orderItems,
            toggle
        }
    },
}
</script>
<style lang="scss" scoped>
    .campaign-name {
        width: calc(100% - 100px);
    }
</style>